module.exports = "<div class=\"lui-sidebar\" seed>\r\n    <div class=\"lui-chevron-right\">\r\n        <slot name=\"controls\"></slot>\r\n    </div>\r\n    <div class=\"lui-logo\">\r\n        <slot name=\"logo\"></slot>\r\n    </div>\r\n    <slot></slot>    \r\n</div>\r\n<div class=\"lui-sidebar-panel\">\r\n    <slot name=\"panel\"></slot>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-sidebar/theme/lui-sidebar.html
// module id = 316
// module chunks = 0 1 27